module.exports = __webpack_public_path__ + "d2150c37354cec542e125b8cef408051.jpg";